/** "1811.23" or "-8.00" to "$1,811.23" / "-$8.00". String-based: no floats. */
export function dollars(decimal: string): string {
  const negative = decimal.startsWith('-');
  const [whole = '0', cents = '00'] = decimal.replace('-', '').split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${negative ? '-' : ''}$${grouped}.${cents.padEnd(2, '0')}`;
}

/** Minor units as a string ("68238") to a decimal string ("682.38"). */
export function fromCents(minor: string): string {
  const negative = minor.startsWith('-');
  const digits = minor.replace('-', '').padStart(3, '0');
  return `${negative ? '-' : ''}${digits.slice(0, -2)}.${digits.slice(-2)}`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2026-09-30" to "30 Sep 2026". */
export function day(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${Number(d)} ${MONTHS[Number(m) - 1] ?? ''} ${y}`;
}
